import React, { Component } from 'react'

export type CasePickerItemSize = 'medium' | 'large' | 'double'
export type CasePickerItemStatus = 'selected' | 'available' | 'unavailable'
type CasePickerItemSizes = Record<CasePickerItemProps['size'], string>
type CasePickerItemStatuses = Record<CasePickerItemProps['status'], string>

interface CasePickerItemProps {
  size: CasePickerItemSize
  status: CasePickerItemStatus
  label?: string
  position?: number
}

export default class CasePickerItem extends Component<CasePickerItemProps> {
  casePickerSizes: CasePickerItemSizes = {
    medium: 'w-14 h-14 text-xl',
    large: 'w-28 h-28 text-5xl',
    double: 'w-56 h-28 text-5xl'
  }

  casePickerStatuses: CasePickerItemStatuses = {
    selected: 'bg-green-500 text-white',
    available: 'bg-secondary text-white',
    unavailable: 'bg-white text-tertiary border border-primary'
  }

  get className () {
    const base = 'flex items-center justify-center font-medium'
    const size = this.casePickerSizes[this.props.size]
    const status = this.casePickerStatuses[this.props.status]
    return `${base} ${size} ${status}`
  }

  get text () {
    const { position, label } = this.props
    return position || (label || '')
  }

  render () {
    return (
      <div className={this.className}>
        {this.text}
      </div>
    )
  }
}
